import React from 'react';
import { UserMessage, SystemMessage } from '../types/space';
interface MessageBubbleProps {
  message: UserMessage | SystemMessage;
}
export function MessageBubble({
  message
}: MessageBubbleProps) {
  const isUser = message.type === 'user';
  const sender = isUser ? (message as UserMessage).sender : undefined;
  const isCurrentUser = isUser && !sender;
  const isOtherUser = isUser && !!sender;
  return <div className={`flex w-full mb-4 ${isCurrentUser ? 'justify-end' : 'justify-start'}`} data-id="element-112">
      {/* Avatar for system or other users */}
      {!isCurrentUser && <div className="flex-shrink-0 mr-3 mt-1" data-id="element-113">
          {isOtherUser && sender ? <div className={`h-8 w-8 rounded-full ${sender.color} flex items-center justify-center text-xs font-bold ${sender.textColor}`} data-id="element-114">
              {sender.initials}
            </div> : <div className="h-8 w-8 rounded-full bg-indigo-600 flex items-center justify-center text-white text-xs font-bold" data-id="element-115">
              R
            </div>}
        </div>}

      <div className={`flex flex-col max-w-[70%] ${isCurrentUser ? 'items-end' : 'items-start'}`} data-id="element-116">
        {/* Sender name for other users */}
        {isOtherUser && sender && <span className="text-xs font-medium text-gray-500 mb-1 px-1" data-id="element-117">
            {sender.name}
          </span>}

        <div className={`
            px-5 py-3 text-sm leading-relaxed shadow-sm
            ${isCurrentUser ? 'bg-blue-600 text-white rounded-2xl rounded-br-sm' : isOtherUser ? 'bg-gray-100 text-gray-800 rounded-2xl rounded-bl-sm' : 'bg-white border border-gray-200 text-gray-800 rounded-2xl rounded-bl-sm'}
          `} data-id="element-118">
          {message.content}
        </div>
        <span className="text-[10px] text-gray-400 mt-1 px-1" data-id="element-119">
          {message.timestamp.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit'
        })}
        </span>
      </div>
    </div>;
}